// extracted by mini-css-extract-plugin
module.exports = {"view":"_16521","flex":"_7907"};